import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AlertService } from 'src/app/services/common/alert.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-admin-reset-password-dialog',
  templateUrl: './admin-reset-password-dialog.component.html',
})
export class AdminResetPasswordDialogComponent {
  form: FormGroup;
  submitted = false;

  constructor(
    private fb: FormBuilder,
    private userService: UserService,
    private alertService: AlertService,
    private dialogRef: MatDialogRef<AdminResetPasswordDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { userId: string; userName: string },
  ) {
    this.form = this.fb.group(
      {
        newPassword: ['', [Validators.required, Validators.minLength(6)]],
        confirmPassword: ['', Validators.required],
      },
      { validators: this.passwordMatchValidator },
    );
  }

  passwordMatchValidator(group: FormGroup) {
    const password = group.get('newPassword')?.value;
    const confirm = group.get('confirmPassword')?.value;
    return password === confirm ? null : { mismatch: true };
  }

  submit() {
    this.submitted = true;
    if (this.form.invalid) {
      return;
    }

    this.userService
      .adminSetPassword({
        userId: this.data.userId,
        newPassword: this.form.value.newPassword,
      })
      .subscribe({
        next: (response: any) => {
          if (response.success) {
            this.alertService.showSuccess('Password updated successfully');
            this.dialogRef.close(true);
          } else {
            this.alertService.showError(response.message || 'Failed to update password');
          }
        },
        error: () => {
          this.alertService.showError('Something went wrong. Please try again.');
        },
      });
  }

  cancel() {
    this.dialogRef.close(false);
  }
}
